import React, { useState, useEffect, useCallback, useRef, useMemo } from "react";
import axios from "axios";
import { Box, Grid, Paper, Typography, TextField, Button, Autocomplete, Dialog, DialogContent, Divider, CircularProgress, Tooltip, IconButton, Snackbar, useTheme, Table, TableHead, TableRow, TableCell, TableBody, TableFooter, DialogTitle, DialogActions, CardContent, Card, Checkbox, Avatar, Collapse, LinearProgress } from "@mui/material";
import { Add as AddIcon, Delete as DeleteIcon, KeyboardArrowDown, KeyboardArrowUp } from "@mui/icons-material";
import { DataGrid } from "@mui/x-data-grid";
import MuiAlert from "@mui/material/Alert";
// import ClientMaster from "./ClientMaster";
import CitySearchInput from "../components/CitySearchInput";
import CityPopupModal from "../components/CityPopupModal";
import { useNavigate, useLocation, useParams } from "react-router-dom";
import { useAuth } from '../context/AuthContext';
import { toProperCase } from "../utils/formatRows";
import CustomNoDataOverlay from "../components/CustomNoDataOverlay";
import { useMediaQuery } from "@mui/system";
import NoDataComponent from "../components/NoDataComponent";
import PhoneIcon from '@mui/icons-material/Phone';
import PersonIcon from '@mui/icons-material/Person';
import ReceiptIcon from '@mui/icons-material/Receipt';
import InputAdornment from '@mui/material/InputAdornment';
import SearchIcon from '@mui/icons-material/Search';
import ClientMaster from "./ClientMaster";

function getInitials(name) {
    if (!name) return 'C';
    return name.trim().charAt(0).toUpperCase();
}

function stringToColor(string) {
    let hash = 0;
    for (let i = 0; i < string.length; i++) {
        hash = string.charCodeAt(i) + ((hash << 5) - hash);
    }
    const colors = ['#e74c3c', '#3498db', '#2ecc71', '#e67e22', '#9b59b6', '#1abc9c', '#3f51b5', '#e91e63', '#795548', '#00bcd4'];
    return colors[Math.abs(hash) % colors.length];
}

export default function ClientConsigneeMaster({ onSaved, mode, connectionString, onPopupCancel, clientId, clientFirmName, onBack, activeViewHandler, tempRows, setTempRows, isFinalSubmitting }) {

    const { user, selectedCompany, loading } = useAuth();
    const role = user?.UserCategory;
    const theme = useTheme();
    const API = connectionString;
    const companyId = selectedCompany?.CompId;
    const userId = user?.UserId;
    const wrapperRef = useRef(null);

    const isSmallScreen = useMediaQuery(theme.breakpoints.down('md'));

    const [showForm, setShowForm] = useState(true);
    const [showGrid, setShowGrid] = useState(true);
    const [isEditingTemp, setIsEditingTemp] = useState(false);

    // const [tempRows, setTempRows] = useState([]);




    const [mobileSearchQuery, setMobileSearchQuery] = useState('');
    const [selectAll, setSelectAll] = useState(false);

    const transform = (data, idKey, valKey) => data.map(item => ({ id: item[idKey], label: item[valKey] }));

    const [localMode, setLocalMode] = useState(mode);
    const [form, setForm] = useState({ ConName: "", Address: "", City: "", Pincode: "", Distance: "", State: "", Statecode: "", PANNo: "", ContactPerson: "", Mobile: "", Email: "" });
    const [errors, setErrors] = useState({});
    const validators = {
        PANNo: (v) => v === "" || /^[A-Z]{5}[0-9]{4}[A-Z]{1}$/.test(v),
        Mobile: (v) => v === "" || /^\d{10}$/.test(v),
        Email: (v) => v === "" || /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(v),
        Pincode: (v) => v === "" || /^\d{1,6}$/.test(v), // typing
    };

    const [editId, setEditId] = useState(null);

    const [partyName, setPartyName] = useState("");
    const [partyID, setPartyID] = useState(null);
    const [selectedParty, setSelectedParty] = useState(null);
    const [dropdownOpen, setDropdownOpen] = useState(false);
    const [suggestions, setSuggestions] = useState([]);

    const [cityQuery, setCityQuery] = useState("");
    const [selectedCity, setSelectedCity] = useState(null);
    const [cityError, setCityError] = useState("");
    const [cityResults, setCityResults] = useState([]);
    const [showCityModal, setShowCityModal] = useState(false);

    const [rows, setRows] = useState([]);
    const [selectionModel, setSelectionModel] = useState([]);
    const [loadingGrid, setLoadingGrid] = useState(false);
    const [paginationModel, setPaginationModel] = useState({ page: 0, pageSize: 50 });
    const [totalCount, setTotalCount] = useState(0);
    const [confirmOpen, setConfirmOpen] = useState(false);
    const [deleting, setDeleting] = useState(false);

    console.log("selectionModel", selectionModel)

    const [accountOptions, setAccountOptions] = useState([]);
    const [selectedAccount, setSelectedAccount] = useState(null);

    const [snackbar, setSnackbar] = useState({ open: false, message: '', severity: 'success' });
    const cityInputRef = useRef(null);
    const [showClientModal, setShowClientModal] = useState(false);
    const EMAIL_SUGGESTIONS = [
        'nomail@gmail.com',
    ];
    const [showEmailSuggestions, setShowEmailSuggestions] = useState(false);

    // ============ GST VERIFICATION STATE ============
    const [gstVerifyNo, setGstVerifyNo] = useState("");
    const [gstVerifyError, setGstVerifyError] = useState("");
    const [gstVerifyValid, setGstVerifyValid] = useState(null);
    const [gstVerifyLoading, setGstVerifyLoading] = useState(false);
    const [companyName, setCompanyName] = useState("")

    const navigate = useNavigate();
    const location = useLocation();
    // const { clientId, clientFirmName, partyId } = location.state || {};
    const { conId, partyId } = useParams();

    const requiredLabelSX = {
        '& .MuiFormLabel-asterisk': {
            color: 'red',
        },
    };

    const totalRows = tempRows.length + rows.length;

    const filteredMobileRows = useMemo(() => {
        const allRows = [...tempRows, ...rows];

        if (!isSmallScreen) return allRows;
        if (!mobileSearchQuery.trim()) return allRows;

        const q = mobileSearchQuery.toLowerCase();

        return allRows.filter((row) => {
            const name = row.ConName?.toLowerCase() || "";
            return ( name.startsWith(q) || row.GSTNO?.toLowerCase().includes(q) || row.ContactPerson?.toLowerCase().includes(q) );
        });
    }, [rows, tempRows, mobileSearchQuery, isSmallScreen]);

    const toggleSelectAll = () => {
        if (selectAll) {
            setSelectionModel([]);
            setSelectAll(false);
        } else {
            const allIds = filteredMobileRows.map(row => row.ConID);
            setSelectionModel(allIds);
            setSelectAll(true);
        }
    };

    useEffect(() => {
        if (!clientId) return;

        // Pre-populate with the passed client data
        setPartyID(clientId);
        setPartyName(clientFirmName || '');
        setSelectedParty({ id: clientId, FirmName: clientFirmName || '' });
    }, [clientId, clientFirmName]);

    useEffect(() => {
        if (!partyId) return;

        const pid = Number(partyId);
        setPartyID(pid);

        (async () => {
            try {
                console.log(pid)
                const party = await fetchPartyById(pid);
                if (party) {
                    setPartyName(party.FirmName ?? "");
                    // setSelectedParty({
                    //     id: party.PartyID ?? pid,
                    //     FirmName: party.FirmName ?? ""
                    // });
                    setSelectedParty({ id: party.id ?? party.PartyID ?? pid, FirmName: party.FirmName ?? "" });
                }
            } catch (err) {
                console.warn("Could not fetch party info:", err);
            }
        })();
    }, [partyId]);

    // useEffect(() => {
    //     if (clientId && clientFirmName) {
    //         setPartyName(clientFirmName);
    //         setPartyID(clientId);
    //         setSelectedParty({ id: clientId, FirmName: clientFirmName });
    //     }
    // }, [clientId, clientFirmName]);

    useEffect(() => {
        if (!partyName || !dropdownOpen) {
            setSuggestions([]);
            return;
        }
        (async () => {
            const data = await fetchPartySuggestions(partyName);
            setSuggestions(data);
        })();
    }, [partyName, dropdownOpen]);

    useEffect(() => {
        const fetchAccounts = async () => {
            try {
                const res = await axios.get(`${API}/api/company-search`, { params: { field: 'FirmName', companyId: companyId } });
                const accountData = transform(res.data.data || [], 'id', 'FirmName');
                setAccountOptions(accountData);
                if (form.accountId) {
                    const found = accountData.find(opt => String(opt.id) === String(form.accountId));
                    setSelectedAccount(found || null);
                } else {
                    setSelectedAccount(null);
                }
            } catch (err) {
                console.error('Error fetching accounts:', err);
                setAccountOptions([]);
                setSelectedAccount(null);
            }
        };
        fetchAccounts();
    }, [form.accountId]);

    useEffect(() => {
        if (!cityQuery) {
            setCityResults([]);
            return;
        }
        const delayDebounce = setTimeout(async () => {
            try {
                const res = await axios.get(`${API}/api/city-search`, { params: { q: cityQuery } });
                setCityResults(res.data || []);
            } catch (err) {
                setCityResults([]);
            }
        }, 400);
        return () => clearTimeout(delayDebounce);
    }, [cityQuery]);

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (
                wrapperRef.current &&
                !wrapperRef.current.contains(event.target)
            ) {
                setDropdownOpen(false);
            }
        };

        document.addEventListener("mousedown", handleClickOutside);

        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, []);

    const fetchGrid = useCallback(async () => {
        if (!partyID) return;
        setLoadingGrid(true);
        try {
            const resp = await axios.get(`${API}/api/consignee-getData-byPartyId`, { params: { PartyID: partyID, userId, companyId, offset: paginationModel.page * paginationModel.pageSize, limit: paginationModel.pageSize }, headers: { 'Cache-Control': 'no-store' }, validateStatus: (s) => (s >= 200 && s < 300) || s === 304 });
            const rawData = resp.data.success && Array.isArray(resp.data?.data) ? resp.data.data : [];
            const total = resp.data.success && typeof resp.data?.total === 'number' ? resp.data.total : 0;
            // REMOVE DECIMAL PART FROM DISTANCE
            const data = rawData.map(row => ({
                ...row,
                Distance:
                    row.Distance !== null && row.Distance !== undefined
                        ? Math.trunc(Number(row.Distance))
                        : row.Distance
            }))
            setRows(data);
            setTotalCount(total);
            console.log(data);
        } catch (err) {
            console.error('Error fetching consignee data:', err);
            setRows([]);
            setTotalCount(0);
            setSnackbar({ open: true, message: 'Failed to fetch consignee data.', severity: 'error' });
        } finally {
            setLoadingGrid(false);
        }
    }, [partyID, userId, companyId, paginationModel, API]);

    useEffect(() => {
        if (partyID == null) return;
        fetchGrid();
    }, [partyID, fetchGrid]);

    const fetchPartySuggestions = async (query) => {
        try {
            const res = await axios.get(`${API}/api/company-search`, { params: { field: "FirmName", search: query, companyId } });
            return res.data.data || [];
        } catch {
            return [];
        }
    };

    const fetchPartyById = async (id) => {
        if (!id) return null;
        try {
            // const res = await axios.get(`${API}/api/company/${id}`);
            // if (res.data && res.data.data) return res.data.data;
            console.log(id);
            const fallback = await axios.get(`${API}/api/company-search`, { params: { field: "id", search: id, companyId: companyId } });
            const list = fallback.data?.data || [];
            console.log(list);
            return list.length ? list[0] : null;
        } catch (err) {
            console.warn("fetchPartyById failed", err);
            return null;
        }
    };

    const handlePartyChange = (_, option) => {
        if (option?.id === "add-new") {
            setShowClientModal(true);
            setDropdownOpen(false);
        } else {
            setShowClientModal(false);
            setSelectedParty(option);
            setPartyID(option?.id || null);
            setPartyName(option?.FirmName || '');
            setDropdownOpen(false);
        }
    };

    // const handleBlur = (key) => () => {
    //     if (!validators[key]) return;

    //     const val = form[key]?.trim() || "";

    //     if (!validators[key](val)) {
    //         setErrors(e => ({ ...e, [key]: true }));
    //     } else {
    //         setErrors(e => ({ ...e, [key]: false }));
    //     }
    // };

    const handleBlur = (key) => () => {
        const val = form[key]?.trim() || "";

        //  PINCODE → EXACTLY 6 digits
        if (key === "Pincode") {
            if (val && !/^\d{6}$/.test(val)) {
                setErrors(e => ({ ...e, Pincode: true }));
            } else {
                setErrors(e => ({ ...e, Pincode: false }));
            }
            return;
        }

        // ⬇️ baaki fields same
        if (!validators[key]) return;

        if (!validators[key](val)) {
            setErrors(e => ({ ...e, [key]: true }));
        } else {
            setErrors(e => ({ ...e, [key]: false }));
        }
    };


    const validateFormBeforeSubmit = () => {
        let newErrors = {};
        console.log("form.Distance ", form.Distance)
        // 🔴 Required checks
        if (!form.ConName?.trim()) newErrors.ConName = true;
        // 🟡 OPTIONAL VALIDATION (only if filled)

        if (form.Pincode && !/^\d{6}$/.test(form.Pincode)) {
            newErrors.Pincode = true;
        }

        if (form.Distance && !/^\d+$/.test(form.Distance)) {
            newErrors.Distance = true;
        }

        if (form.City && !form.City.trim()) {
            newErrors.City = true;
        }

        // ❌ If required missing → stop here
        if (Object.keys(newErrors).length > 0) {
            setErrors(newErrors);
            setSnackbar({
                open: true,
                severity: "error",
                message: "Required fields are missing",
            });
            return false;
        }


        // 🟡  PAN submit validation(ONLY if filled)
        if (form.PANNo && !validators.PANNo(form.PANNo)) {
            setErrors(e => ({ ...e, PANNo: true }));
            setSnackbar({
                open: true,
                severity: "error",
                message: "Invalid PAN Number",
            });
            return false;
        }

        // 🟡 Mobile validation (ONLY if filled)
        if (form.Mobile && !validators.Mobile(form.Mobile)) {
            setErrors({ Mobile: true });
            setSnackbar({
                open: true,
                severity: "error",
                message: "Invalid mobile number",
            });
            return false;
        }


        if (form.Email && !validators.Email(form.Email)) {
            setSnackbar({ open: true, message: "Invalid Email Address", severity: "error" });
            return;
        }

        // ✅ All good
        setErrors({});
        return true;
    };

    // ============ GST AUTO FILL ============
    const handleGstAutoFill = async () => {
        if (gstVerifyNo.length !== 15) {
            setSnackbar({ open: true, message: "Please enter a valid 15-character GST No", severity: "error" });
            return;
        }

        if (!gstVerifyValid) {
            setSnackbar({ open: true, message: "Invalid GST format", severity: "error" });
            return;
        }

        try {
            setGstVerifyLoading(true);
            const gstRes = await axios.get(`${API}/api/gst-lookup`, { params: { searchGstin: gstVerifyNo } });
            const d = gstRes.data.data || {};

            // Fill the consignee form fields from GST data
            setForm(prev => ({
                ...prev,
                ConName: d.clientName || "",
                ContactPerson: d.contactPerson || "",
                Address: d.address || "",
                City: d.city || "",
                Pincode: d.PinCode ? String(d.PinCode) : "",
                State: d.state || "",
                Statecode: d.stateCode || gstVerifyNo.slice(0, 2),
            }));

            // ✅ Also set cityQuery to display city in the form
            if (d.city) {
                setCityQuery(d.city);
            }

            setSnackbar({ open: true, message: "GST details fetched successfully", severity: "success" });
        } catch (gstErr) {
            setGstVerifyValid(false);
            const errorMsg = gstErr.response?.data?.message || "Unable to fetch details for given GST No.";
            setSnackbar({ open: true, message: errorMsg, severity: "error" });
            setGstVerifyError(errorMsg);
        } finally {
            setGstVerifyLoading(false);
        }
    };

    const properCaseFields = [
        "ConName",
        "ContactPerson",
        "Address"
    ];


    const handleChange = key => e => {
        const { value } = e.target;

        setForm(f => ({
            ...f,
            [key]: properCaseFields.includes(key)
                ? toProperCase(value)
                : value
        }));
    };

    const resetAndCancel = () => {
        setLocalMode("add");
        setEditId(null);
        setPartyID(null);
        setPartyName("");
        setSelectedParty(null);
        setSelectedAccount(null);
        setCityQuery("");
        setForm({ ConName: "", Address: "", City: "", Pincode: "", Distance: "", State: "", Statecode: "", PANNo: "", ContactPerson: "", Mobile: "", Email: "" });
        setGstVerifyNo("");
        setGstVerifyError("");
        setGstVerifyValid(null);
        setErrors({});
        setRows([]);
        setTotalCount(0);
        if (typeof onPopupCancel === "function") {
            onPopupCancel();      // ✅ close popup
        }

    };

    const FN_HandleSubmit = async () => {
        if (!partyID) {
            setSnackbar({ open: true, message: "Please select a Party", severity: 'error' });
            return;
        }
        if (!form.ConName?.trim()) {
            setSnackbar({ open: true, message: "Consignee Name is required", severity: 'error' });
            return;
        }
        // 🟡 OPTIONAL VALIDATION

        if (form.Pincode && !validators.Pincode(form.Pincode)) {
            setErrors(e => ({ ...e, Pincode: true }));
            setSnackbar({ open: true, message: "Invalid Pincode", severity: 'error' });
            return;
        }

        if (form.City && !form.City.trim()) {
            setErrors(e => ({ ...e, City: true }));
            setSnackbar({ open: true, message: "Invalid City", severity: 'error' });
            return;
        }
        const payload = { PartyID: partyID, ...form, Distance: form.Distance === "" ? 0 : form.Distance, companyId, userId, accountId: selectedAccount?.id || null };
        try {
            if (localMode === "add") {
                await axios.post(`${API}/api/consignee/insert`, payload);
                if (typeof onPopupCancel === "function") {
                    setSnackbar({ open: true, message: "Consignee added successfully!", severity: 'success' })
                    setTimeout(() => { onPopupCancel() }, 600)
                }
                else {
                    setSnackbar({ open: true, message: "Consignee added successfully!", severity: 'success' })
                    setTimeout(() => {
                        // navigate(-1);
                        if (activeViewHandler) {
                            activeViewHandler()
                        } else {
                            navigate(-1)
                        }
                    }, 600);
                }

            }
            else if (editId != null) {
                await axios.put(`${API}/api/consignee/update/${editId}`, payload);
                if (typeof onPopupCancel === "function") {
                    onPopupCancel()
                }
                else {
                    setSnackbar({ open: true, message: "Consignee updated successfully!", severity: 'success' })
                    setTimeout(() => {
                        // navigate(-1);
                        if (activeViewHandler) {
                            activeViewHandler()
                        } else {
                            navigate(-1)
                        }
                    }, 600);
                }
            }
            onSaved?.();
            resetAndCancel();
        } catch (error) {
            console.error('Save error:', error);
            setSnackbar({ open: true, message: "Save failed.", severity: 'error' });
        }
    };

    const handleAddTempConsignee = () => {
        if (isFinalSubmitting) return;

        const tempId = `temp-${Date.now()}`;

        const newTempRow = {
            ConID: tempId,          // 🔴 temp id
            isTemp: true,           // 🔴 flag
            ...form,
            GSTNO: gstVerifyNo,
        };

        setTempRows(prev => [...prev, newTempRow]);
        setErrors({});
        setCityError("")

        // optional: form reset
        setForm({
            ConName: "",
            Address: "",
            City: "",
            Pincode: "",
            Distance: "",
            State: "",
            Statecode: "",
            PANNo: "",
            ContactPerson: "",
            Mobile: "",
            Email: "",
        });

        setGstVerifyNo("");
        setGstVerifyError("");
        setGstVerifyValid(null);
        setSelectedCity(null);
        setCityQuery("");
    };

    const resetFormAfterEdit = () => {
        setLocalMode("add");
        setEditId(null);
        setIsEditingTemp(false);

        setForm({
            ConName: "",
            Address: "",
            City: "",
            Pincode: "",
            Distance: "",
            State: "",
            Statecode: "",
            PANNo: "",
            ContactPerson: "",
            Mobile: "",
            Email: "",
        });

        setGstVerifyNo("");
        setGstVerifyError("");
        setGstVerifyValid(null);
        setCityQuery("");
        setSelectedCity(null);
    };


    const handleUpdateConsignee = async () => {
        if (!editId) return;

        // ================= TEMP ROW UPDATE =================
        if (isEditingTemp) {
            setTempRows(prev =>
                prev.map(row =>
                    row.ConID === editId
                        ? { ...row, ...form }   // ✅ update same row
                        : row
                )
            );

            setSnackbar({
                open: true,
                severity: "success",
                message: "Temp consignee updated",
            });

            resetFormAfterEdit();
            setLocalMode("add");
            setEditId(null);
            setIsEditingTemp(false);
            return;
        }

        // ================= DB ROW UPDATE =================
        try {
            const payload = {
                PartyID: partyID,
                ...form,
                GSTNO: gstVerifyNo,
                Distance: form.Distance === "" ? 0 : form.Distance,
                companyId,
                userId,
            };

            await axios.put(`${API}/api/consignee/update/${editId}`, payload);

            setSnackbar({
                open: true,
                severity: "success",
                message: "Consignee updated successfully",
            });

            fetchGrid();   // refresh DB data
            resetFormAfterEdit();
            setLocalMode("add");
            setEditId(null);
            setIsEditingTemp(false)

        } catch (err) {
            console.error(err);
            setSnackbar({
                open: true,
                severity: "error",
                message: "Update failed",
            });
        } finally {
            setErrors({});
        }
    };


    const handleDelete = async () => {
        if (!selectionModel.length || deleting) return;

        // 1️⃣ Split temp & real IDs
        const tempIds = selectionModel.filter(id =>
            String(id).startsWith("temp-")
        );

        const realIds = selectionModel.filter(id =>
            !String(id).startsWith("temp-")
        );

        // 2️⃣ Remove TEMP rows locally
        if (tempIds.length) {
            setTempRows(prev =>
                prev.filter(row => !tempIds.includes(row.ConID))
            );
        }

        // const isTempSelected =
        //     selectionModel.some(id => String(id).startsWith("temp-"));

        // // ✅ 1. Remove TEMP rows locally
        // if (tempIds.length) {
        //     setTempRows(prev =>
        //         prev.filter(row => !tempIds.includes(row.ConID))
        //     );
        // }
        // if (isTempSelected && !realIds.length) {
        //     setSnackbar({
        //         open: true,
        //         message: "Temp consignee removed",
        //         severity: "success",
        //     });
        // }

        // 3️⃣ If ONLY temp rows selected → stop heres
        if (tempIds.length && !realIds.length) {
            setSnackbar({
                open: true,
                message: "Temp consignee(s) removed",
                severity: "success",
            });
            setSelectionModel([]);
            setConfirmOpen(false);
            return;
        }
        if (realIds.length) setDeleting(true);
        if (realIds.length) try {
            const response = await axios.post(`${API}/api/consignee/delete`, { userId, objAryId: realIds });
            setSnackbar({ open: true, message: 'Deleted successfully.', severity: 'success' });
            setSelectionModel([]);
            fetchGrid();
        } catch (error) {
            const status = error.response?.status;
            const data = error.response?.data;
            // 🔴 Case: 400 + referenced IDs (business rule failure)
            if (status === 400 && data?.referencedIds?.length > 0) {
                setSnackbar({
                    open: true,
                    message: "Cannot delete the selected item(s) because they are referenced in other records.",
                    severity: "warning"
                });
            } else if (status === 400 && data?.error) {
                // 🔴 400 but no referencedIds array (generic validation)
                setSnackbar({
                    open: true,
                    message: data.error,
                    severity: "warning"
                });
            } else {
                // 🔴 unexpected / server error
                setSnackbar({
                    open: true,
                    message: "Delete failed due to an unexpected error.",
                    severity: "error"
                });
            }
        } finally {
            setDeleting(false);
            setConfirmOpen(false);
        }
    };

    const renderConsigneeCards = () => {
        if (loadingGrid) {
            return (
                <Box sx={{ display: 'flex', justifyContent: 'center', py: 4 }}>
                    <CircularProgress />
                </Box>
            );
        }

        if (filteredMobileRows.length === 0) {
            return (
                <Box sx={{ p: 4, textAlign: 'center' }}>
                    <CustomNoDataOverlay />
                </Box>
            );
        }


        if (rows.length === 0) {
            return (
                <Box sx={{ p: 4, textAlign: 'center' }}>
                    <CustomNoDataOverlay />
                    <Typography sx={{ mt: 1, fontSize: '0.85rem', color: 'text.secondary' }}>
                        Page: {paginationModel.page + 1} | Total: {totalCount}
                    </Typography>
                </Box>
            );
        }

        return (
            <>
                {filteredMobileRows.map((row) => {
                    const isSelected = selectionModel.includes(row.ConID);
                    const avatarColor = stringToColor(row.clientFirmName || 'C');
                    const initials = getInitials(row.clientFirmName);
                    const locationText =
                        [row.City, row.State].filter(Boolean).join(', ') || '—';

                    return (
                        <Card
                            key={row.ConID}
                            onClick={() =>
                                navigate(
                                    `/main/edit-consignee/${row.ConID}/${row.PartyID}`,
                                    { state: { partyId: row.PartyID } }
                                )
                            }
                            sx={{
                                mb: 1.5,
                                boxShadow: 3,
                                borderRadius: 2,
                                overflow: "hidden",
                                transition: "0.2s",
                                cursor: "pointer",
                                // 🔥 TEMP CARD COLOR
                                backgroundColor: row.isTemp ? "#fff2c6" : "background.paper",
                                "&:hover": {
                                    backgroundColor: row.isTemp ? "#FFECB3" : "#f1f5f9",
                                },

                                borderLeft: "4px solid",
                                borderLeftColor: row.isTemp
                                    ? theme.palette.warning.main
                                    : theme.palette.primary.main,
                            }}
                        >
                            <CardContent sx={{ py: 1.8, px: 2 }}>
                                {/* Header */}
                                <Box sx={{ display: 'flex', alignItems: 'center', mb: 1 }}>
                                    {role !== 'User' && <Checkbox
                                        size="small"
                                        checked={isSelected}
                                        onClick={(e) => e.stopPropagation()}
                                        onChange={() =>
                                            setSelectionModel((prev) =>
                                                isSelected
                                                    ? prev.filter((id) => id !== row.ConID)
                                                    : [...prev, row.ConID]
                                            )
                                        }
                                        sx={{ mr: 1 }}
                                    />
                                    }

                                    <Avatar
                                        sx={{
                                            bgcolor: avatarColor,
                                            width: 36,
                                            height: 36,
                                            fontWeight: 'bold',
                                            mr: 1.5
                                        }}
                                    >
                                        {initials}
                                    </Avatar>

                                    <Box sx={{ flexGrow: 1, minWidth: 0 }}>
                                        <Typography
                                            sx={{
                                                fontWeight: 600,
                                                fontSize: '1rem',
                                                whiteSpace: 'nowrap',
                                                overflow: 'hidden',
                                                textOverflow: 'ellipsis',
                                                textDecoration: "underline", color: theme.palette.primary.main, cursor: "pointer"
                                            }}

                                            onClick={(e) => {
                                                e.stopPropagation(); // ✅ IMPORTANT (prevents grid re-selection)

                                                if (!row.ConID) return;
                                                setEditId(row.ConID);
                                                setLocalMode("edit");
                                                setIsEditingTemp(!!row.isTemp);

                                                setForm({
                                                    ConName: row?.ConName || "",
                                                    Address: row?.Address || "",
                                                    City: row?.City || "",
                                                    Pincode: row?.Pincode || "",
                                                    Distance: row?.Distance || "",
                                                    State: row?.State || "",
                                                    Statecode: row?.Statecode || "",
                                                    PANNo: row?.PANNo || "",
                                                    ContactPerson: row?.ContactPerson || "",
                                                    Mobile: row?.Mobile || "",
                                                    Email: row?.Email || ""
                                                });

                                                setGstVerifyNo(row?.GSTNO || "");

                                                // ✅ ONLY update display fields (NO partyID change)
                                                setPartyName(prev => prev);
                                                setSelectedParty(prev => prev);

                                                setCityQuery(row?.City || "");
                                            }}
                                        >
                                            {row.ConName || '—'}
                                        </Typography>

                                        <Typography variant="caption" color="text.secondary">
                                            {locationText}
                                        </Typography>
                                    </Box>
                                </Box>

                                {/* Body */}
                                <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
                                    <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
                                        <Box sx={{ display: 'flex', alignItems: 'center' }}>
                                            <PersonIcon fontSize="small" sx={{ mr: 1, color: 'text.secondary' }} />
                                            <Typography variant="body2" color="text.secondary">
                                                {row.ContactPerson || '—'}
                                            </Typography>
                                        </Box>

                                        <Box sx={{ display: 'flex', alignItems: 'center' }}>
                                            <PhoneIcon fontSize="small" sx={{ mr: 1, color: 'primary.main' }} />
                                            <Typography
                                                variant="body2"
                                                sx={{ fontWeight: 500, color: 'primary.main' }}
                                            >
                                                {row.Mobile || '—'}
                                            </Typography>
                                        </Box>
                                    </Box>

                                    <Box sx={{ display: 'flex', alignItems: 'center' }}>
                                        <ReceiptIcon fontSize="small" sx={{ mr: 1, color: 'text.secondary' }} />
                                        <Typography variant="body2" color="text.secondary">
                                            GST: {row.GSTNO || '—'}
                                        </Typography>
                                    </Box>
                                </Box>
                            </CardContent>
                        </Card>
                    );
                })}

                {/* Pagination */}
                <Box
                    sx={{
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                        gap: 2,
                        py: 2
                    }}
                >
                    <Button
                        variant="outlined"
                        disabled={paginationModel.page === 0}
                        onClick={() =>
                            setPaginationModel((p) => ({
                                ...p,
                                page: Math.max(0, p.page - 1)
                            }))
                        }
                    >
                        ← Previous
                    </Button>

                    <Typography variant="body2">
                        Page {paginationModel.page + 1} of{' '}
                        {Math.ceil(totalCount / paginationModel.pageSize) || 1}
                    </Typography>

                    <Button
                        variant="outlined"
                        disabled={
                            (paginationModel.page + 1) * paginationModel.pageSize >= totalCount
                        }
                        onClick={() =>
                            setPaginationModel((p) => ({
                                ...p,
                                page: p.page + 1
                            }))
                        }
                    >
                        Next →
                    </Button>
                </Box>
            </>
        );
    };

    // --- SAFE COLUMNS: guard against missing params / params.row ---
    const columns = [
        {
            field: "ConName",
            headerName: "Consignee Details",
            flex: 1,
            renderCell: (params) => {
                const row = params?.row ?? {};
                const ConID = row?.ConID ?? params?.id;

                const name = row?.ConName ?? "—";
                const city = row?.City;
                const state = row?.State;

                const location =
                    city || state
                        ? [city, state].filter(Boolean).join(", ")
                        : "—";

                return (
                    <Box sx={{ display: "flex", flexDirection: "column", lineHeight: 1.3 }}>
                        {/* 🔹 Consignee Name */}
                        <Typography
                            variant="body2"
                            sx={{
                                fontWeight: 600,
                                textDecoration: "underline",
                                color: theme.palette.primary.main,
                                cursor: "pointer",
                            }}
                            onClick={(e) => {
                                e.stopPropagation();
                                if (!ConID) return;

                                setEditId(row.ConID);
                                setLocalMode("edit");
                                setIsEditingTemp(!!row.isTemp);

                                setForm({
                                    ConName: row?.ConName || "",
                                    Address: row?.Address || "",
                                    City: row?.City || "",
                                    Pincode: row?.Pincode || "",
                                    Distance: row?.Distance || "",
                                    State: row?.State || "",
                                    Statecode: row?.Statecode || "",
                                    PANNo: row?.PANNo || "",
                                    ContactPerson: row?.ContactPerson || "",
                                    Mobile: row?.Mobile || "",
                                    Email: row?.Email || "",
                                });

                                setGstVerifyNo(row?.GSTNO || "");
                                setCityQuery(row?.City || "");
                            }}
                        >
                            {name}
                        </Typography>

                        {/* 🔹 Location under name */}
                        <Typography
                            variant="caption"
                            sx={{ color: "text.secondary" }}
                        >
                            {location}
                        </Typography>
                    </Box>
                );
            },
        },
        // {
        //     field: "location", headerName: "Location", flex: 1,
        //     valueGetter: (value, row) => {
        //         const city = row?.City || "—";
        //         const state = row?.State || "—";
        //         return `${city}, ${state}`;
        //     }
        // },
        { field: "Pincode", headerName: "Pincode", flex: 0.4, },
        { field: "GSTNO", headerName: "GST No.", flex: 0.7, },
        { field: "Mobile", headerName: "Mobile No.", flex: 0.6, },
        {
            flex: 0.1, sortable: false,
            renderCell: (params) => {
                const row = params?.row ?? {};
                const id = row?.ConID ?? params?.id;
                const sel = Array.isArray(selectionModel) ? selectionModel.includes(id) : (selectionModel?.has ? selectionModel.has(id) : false);
                return (
                    <Tooltip title="Delete">
                        <span>

                            <IconButton
                                color="error"
                                size="small"
                                disabled={!sel}
                                onClick={(e) => {
                                    e.stopPropagation();
                                    setConfirmOpen(true);   // 🔥 open dialog
                                }}
                            >
                                <DeleteIcon fontSize="small" />
                            </IconButton>
                        </span>
                    </Tooltip>
                );
            }
        }
    ];

    const dropdownField = (label, options, value, setValue) => (
        <Grid item xs={12} sm={8} md={12}>
            <Autocomplete fullWidth options={options} getOptionLabel={opt => opt?.label || ''} value={value} onChange={(_, v) => setValue(v)} isOptionEqualToValue={(opt, val) => opt?.id === val?.id} disabled={localMode !== "add" && localMode !== "edit"}
                renderInput={params => (
                    <TextField {...params} label={label} size="small" InputLabelProps={{ shrink: Boolean(value) }} sx={{ '& .MuiOutlinedInput-root': { height: 30, display: 'flex', alignItems: 'center' }, '& .MuiOutlinedInput-input': { fontSize: '0.875rem', padding: '0 12px' } }} />
                )}
            />
        </Grid>
    );

    return (
        <Box>
            <Box sx={{ pt: 1.5 }}>
                <Grid container spacing={1.5} alignItems="flex-start">

                    {/* ================= LEFT COLUMN ================= */}
                    <Grid item size={{ xs: 12, md: 8 }}>
                        <Grid container spacing={1.5}>

                            {/* ROW 0 - GST VERIFICATION */}
                            <Grid item size={{ xs: 12, md: 6 }}>
                                <TextField
                                    fullWidth
                                    label="GST No."
                                    size="small"
                                    value={gstVerifyNo}
                                    error={Boolean(gstVerifyError)}
                                    helperText={gstVerifyError || "Enter 15-digit GST number to auto-fill details"}
                                    inputProps={{ maxLength: 15 }}
                                    onChange={(e) => {
                                        const val = e.target.value.toUpperCase();
                                        if (/^[0-9A-Z]*$/.test(val)) {
                                            setGstVerifyNo(val);
                                            const gstRegex = /^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[1-9A-Z]{1}Z[0-9A-Z]{1}$/;
                                            if (!val) {
                                                setGstVerifyError("");
                                                setGstVerifyValid(null);
                                            } else if (!gstRegex.test(val)) {
                                                setGstVerifyError("Invalid pattern");
                                                setGstVerifyValid(false);
                                            } else {
                                                setGstVerifyError("");
                                                setGstVerifyValid(true);
                                            }
                                        }
                                    }}
                                />
                            </Grid>

                            <Grid item size={{ xs: 12, md: 6 }}>
                                <Button
                                    size="small"
                                    variant="contained"
                                    color="primary"
                                    onClick={handleGstAutoFill}
                                    disabled={gstVerifyLoading || gstVerifyNo.length !== 15}
                                    sx={{ mt: 0.5 }}
                                >
                                    {gstVerifyLoading ? <CircularProgress size={16} /> : "Verify & Fill"}
                                </Button>
                            </Grid>

                            {/* ROW 1 */}
                            <Grid item size={{ xs: 12, md: 6 }}>
                                <TextField
                                    fullWidth
                                    required
                                    label="Consignee Name"
                                    size="small"
                                    value={form.ConName}
                                    onChange={handleChange("ConName")}
                                    onBlur={handleBlur("ConName")}
                                    error={Boolean(errors.ConName)}
                                    InputLabelProps={{ sx: requiredLabelSX }}
                                />
                            </Grid>

                            <Grid item size={{ xs: 12, md: 6 }}>
                                <TextField
                                    fullWidth
                                    label="Contact Person"
                                    size="small"
                                    value={form.ContactPerson}
                                    onChange={handleChange("ContactPerson")}
                                />
                            </Grid>

                            {/* ROW 2 */}

                            <Grid item size={{ xs: 12, sm: 6, md: 4 }}>
                                <TextField
                                    fullWidth
                                    label="PAN No."
                                    size="small"
                                    value={form.PANNo}
                                    error={Boolean(errors.PANNo)}
                                    inputProps={{ maxLength: 10 }}
                                    onChange={(e) => {
                                        const val = e.target.value.toUpperCase();

                                        if (/^[A-Z0-9]*$/.test(val)) {
                                            setForm(f => ({ ...f, PANNo: val }));
                                        }
                                    }}
                                    helperText={
                                        errors.PANNo ? "Invalid PAN Number" : ""
                                    }
                                    onBlur={() => {
                                        if (form.PANNo && !validators.PANNo(form.PANNo)) {
                                            setErrors(e => ({ ...e, PANNo: true }));
                                        } else {
                                            setErrors(e => ({ ...e, PANNo: false }));
                                        }
                                    }}
                                />


                            </Grid>

                            <Grid item size={{ xs: 12, sm: 6, md: 4 }}>
                                <TextField
                                    sx={{ width: "100%" }}
                                    label="Mobile"
                                    size="small"
                                    value={form.Mobile}
                                    error={Boolean(errors.Mobile)}
                                    // helperText={errors.Mobile ? "Mobile must be 10 digits" : ""}
                                    inputProps={{ maxLength: 10 }}
                                    onChange={(e) => {
                                        const val = e.target.value.replace(/\D/g, "");
                                        setForm(f => ({ ...f, Mobile: val }));
                                    }}
                                    helperText={
                                        errors.Mobile ? "Must be 10 digits" : ""
                                    }
                                    onBlur={handleBlur("Mobile")}
                                />
                            </Grid>

                            {/* ROW 3 */}
                            <Grid item size={{ xs: 12, sm: 6, md: 4 }}>
                                <TextField
                                    fullWidth
                                    sx={{ width: "100%" }}
                                    label="Email"
                                    size="small"
                                    value={form.Email}
                                    error={Boolean(errors.Email)}
                                    onChange={handleChange("Email")}
                                    onBlur={handleBlur("Email")}
                                    helperText={
                                        errors.Email ? "Invalid Email" : ""
                                    }
                                />

                            </Grid>

                            <Grid item size={{ xs: 6, sm: 6, md: 2 }}>
                                <TextField
                                    label="Pin"
                                    size="small"
                                    sx={{ width: "100%" }}
                                    value={form.Pincode}
                                    error={Boolean(errors.Pincode)}
                                    // helperText={errors.Pincode ? "Pincode must be 6 digits" : ""}
                                    inputProps={{ maxLength: 6 }}
                                    onChange={(e) => {
                                        const val = e.target.value.replace(/\D/g, "");
                                        setForm(f => ({ ...f, Pincode: val }));
                                    }}
                                    onBlur={handleBlur("Pincode")}
                                    helperText={
                                        errors.Pincode ? "Must be 6 digits" : ""
                                    }
                                />
                            </Grid>

                            <Grid item size={{ xs: 6, sm: 6, md: 2 }}>
                                <TextField
                                    fullWidth
                                    sx={{ width: "100%" }}
                                    label="Dist"
                                    size="small"
                                    value={form.Distance}
                                    error={Boolean(errors.Distance)}
                                    inputProps={{
                                        inputMode: "numeric",
                                        pattern: "[0-9]*",
                                        maxLength: 6
                                    }}
                                    onChange={(e) => {
                                        const val = e.target.value;

                                        // ✅ allow only numbers
                                        if (/^\d*$/.test(val)) {
                                            setForm(f => ({ ...f, Distance: val }));
                                        }
                                    }}

                                    onBlur={() => {
                                        if (!form.Distance) {
                                            setErrors(e => ({ ...e, Distance: true }));
                                        } else {
                                            setErrors(e => ({ ...e, Distance: false }));
                                        }
                                    }}
                                />

                            </Grid>

                            <Grid item size={{ xs: 12, md: 4 }}>
                                <CitySearchInput
                                    value={selectedCity?.city || cityQuery}
                                    cities={cityResults}
                                    error={Boolean(errors.City)}
                                    connectionString={connectionString}
                                    onChangeQuery={(q) => {
                                        setCityQuery(q);
                                        if (cityError) setCityError("");
                                    }}
                                    onSelectCity={(c) => {
                                        setSelectedCity(c);
                                        setForm(f => ({
                                            ...f,
                                            City: c.city,
                                            State: c.state,
                                            Statecode: c.stateCode,
                                        }));
                                        setCityQuery("");
                                    }}
                                />
                                {cityError && (
                                    <Typography variant="caption" color="error">
                                        {cityError}
                                    </Typography>
                                )}
                            </Grid>

                        </Grid>
                    </Grid>

                    {/* ================= RIGHT COLUMN ================= */}
                    <Grid item size={{ xs: 12, md: 4 }}>
                        <Grid container spacing={1.5}>

                            {/* Address */}
                            <Grid item size={{ xs: 12 }}>
                                <TextField
                                    fullWidth
                                    label="Address"
                                    size="small"
                                    multiline
                                    minRows={3.2}
                                    value={form.Address}
                                    onChange={handleChange("Address")}
                                />
                            </Grid>

                            {/* State + State Code */}
                            <Grid item size={{ xs: 8 }}>
                                <TextField
                                    fullWidth
                                    label="State"
                                    size="small"
                                    disabled
                                    value={form.State}
                                />
                            </Grid>

                            <Grid item size={{ xs: 4 }}>
                                <TextField
                                    fullWidth
                                    label="State Code"
                                    size="small"
                                    disabled
                                    value={form.Statecode}
                                />
                            </Grid>

                        </Grid>
                    </Grid>

                </Grid>

                <Box display="flex" justifyContent="center" gap={1.5} sx={{ pt: 1.5 }}>
                    <Button variant="contained" color="secondary" size="small" sx={{ px: 2 }} type="button"
                        onClick={() => {
                            if (!validateFormBeforeSubmit()) return;

                            if (localMode === "edit") {
                                handleUpdateConsignee();
                            } else {
                                handleAddTempConsignee();
                            }
                        }} > {localMode === "add" ? "Add" : "Update"} </Button>
                </Box>
            </Box>

            <Box mt={1.5} sx={{ minHeight: totalRows === 0 ? "" : 200 }}>
                {loadingGrid && <CircularProgress />}
                {!loadingGrid && totalRows === 0 ? (
                    <Typography sx={{ textAlign: "center", width: "100%" }}>No Consignee Found</Typography>
                ) : (isSmallScreen ? (
                    <>
                        <Box sx={{ mb: 1, px: 1 }}>
                            <TextField fullWidth size="small" placeholder="Search consignees..." value={mobileSearchQuery} onChange={(e) => setMobileSearchQuery(e.target.value)} variant="outlined"
                                InputProps={{
                                    startAdornment: (
                                        <InputAdornment position="start">
                                            <SearchIcon />
                                        </InputAdornment>
                                    ),
                                }}
                            />
                        </Box>

                        {role !== 'User' && selectionModel.length > 0 && (
                            <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', px: 2, py: 1.5, mb: 2, bgcolor: 'background.paper', borderRadius: 2, boxShadow: 1 }} >
                                <Box sx={{ display: 'flex', alignItems: 'center' }}>
                                    <Checkbox checked={selectAll} onChange={toggleSelectAll} size="small" />
                                    <Typography variant="body2" sx={{ ml: 1 }}>
                                        {selectionModel.length} selected
                                    </Typography>
                                </Box>
                                <Tooltip title="Delete selected">
                                    <IconButton
                                        onClick={(e) => {
                                            e.stopPropagation();
                                            e.preventDefault();
                                            setConfirmOpen(true);
                                        }} color="error">
                                        <DeleteIcon />
                                    </IconButton>
                                </Tooltip>
                            </Box>
                        )}
                        <Box sx={{ width: '100%', overflowX: 'hidden', px: 1 }}>
                            {renderConsigneeCards()}
                        </Box>
                    </>
                ) : (
                    <DataGrid
                        // autoHeight
                        // rows={rows}
                        rows={[...tempRows, ...rows]}
                        columns={columns}
                        // getRowId={r => r.ConID}
                        getRowClassName={(params) =>
                            params.row.isTemp ? "temp-row" : ""
                        }
                        getRowId={(row) => row.ConID}
                        checkboxSelection
                        selectionModel={selectionModel}
                        onRowSelectionModelChange={(newSelection) => {
                            setSelectionModel(newSelection);
                        }}
                        columnHeaderHeight={38}
                        rowHeight={43}
                        getRowHeight={() => 'auto'}
                        disableSelectionOnClick
                        loading={loadingGrid}
                        pagination
                        paginationMode="server"
                        page={paginationModel.page}
                        slots={{
                            noResultsOverlay: CustomNoDataOverlay
                        }}
                        slotProps={{
                            noResultsOverlay: {
                                width: 110,
                                mb: 1,
                                fontSize: "12px"
                            },
                        }}
                        pageSize={paginationModel.pageSize}
                        rowCount={totalCount}
                        onPageChange={page => setPaginationModel(p => ({ ...p, page }))}
                        onPageSizeChange={sz => setPaginationModel(p => ({ ...p, pageSize: sz }))}
                        pageSizeOptions={[25, 50, 100]}
                        sx={{
                            '& .MuiDataGrid-columnHeaders': { backgroundColor: '#E0E0E0' },
                            '& .MuiDataGrid-columnHeaderTitle': { fontWeight: 500 },
                            '& .MuiDataGrid-columnHeader': { backgroundColor: '#E0E0E0', color: '#000000', fontWeight: 'bold', },

                            // Background styling
                            '& .MuiDataGrid-filler': { backgroundColor: '#FFFFFF' },
                            '& .MuiDataGrid-scrollbarFiller': { backgroundColor: '#E0E0E0' },

                            // Row styling
                            '& .MuiDataGrid-row:nth-of-type(odd)': { backgroundColor: '#FFFFFF' },
                            '& .MuiDataGrid-row:nth-of-type(even)': { backgroundColor: '#F9FAFB' },
                            '& .MuiDataGrid-row:hover': { backgroundColor: '#f1f5f9' },

                            // Selected row styling (with !important to override default MUI)
                            '& .MuiDataGrid-row.Mui-selected': { backgroundColor: '#BDBDBD !important' },

                            // Cell content alignment
                            '& .MuiDataGrid-cell': {
                                display: 'flex',
                                alignItems: 'center',
                                whiteSpace: 'normal',
                                wordBreak: 'break-word',
                            },
                            '& .MuiDataGrid-footerContainer': {
                                minHeight: 32,
                                height: 32,
                            },
                            "& .MuiDataGrid-row.temp-row": {
                                backgroundColor: "#fff2c6 !important",
                            },
                            "& .MuiDataGrid-row.temp-row:hover": {
                                backgroundColor: "#FFECB3 !important",
                            },
                            minHeight: "200px",
                            height: "200px",


                        }}
                    />
                )
                )}
            </Box>

            <Dialog fullWidth maxWidth="md" open={showClientModal} onClose={(event, reason) => { if (reason === 'backdropClick') return; setShowClientModal(false); }} >
                <DialogContent>
                    <ClientMaster mode="add" onPopupCancel={() => setShowClientModal(false)}
                        onSaved={newClient => {
                            setShowClientModal(false);
                            fetchPartySuggestions();
                        }}
                        connectionString={connectionString}
                    />
                </DialogContent>
            </Dialog>

            {showCityModal && (
                <CityPopupModal onClose={() => setShowCityModal(false)}
                    onCityAdded={c => {
                        setForm(f => ({ ...f, City: c.city, State: c.state, Statecode: c.stateCode }));
                        setCityQuery(c.city);
                        setShowCityModal(false);
                    }}
                />
            )}
            <Snackbar open={snackbar.open} autoHideDuration={1500} onClose={() => setSnackbar(s => ({ ...s, open: false }))} anchorOrigin={{ vertical: "bottom", horizontal: "center" }} >
                <MuiAlert elevation={6} variant="filled" severity={snackbar.severity} sx={{ width: "100%" }} onClose={() => setSnackbar(s => ({ ...s, open: false }))} >
                    {snackbar.message}
                </MuiAlert>
            </Snackbar>

            <Dialog open={confirmOpen} onClose={() => { if (!deleting) setConfirmOpen(false); }} maxWidth="xs" fullWidth>
                {deleting
                    ? <LinearProgress color="error" sx={{ height: 4 }} />
                    : <Box sx={{ height: 4, background: 'linear-gradient(90deg, #d32f2f 0%, #f44336 100%)' }} />}
                <Box sx={{ px: 2.5, pt: 2, pb: 1.5 }}>
                    <Typography variant="h6" fontWeight={700} sx={{ color: 'error.main', fontSize: '1.05rem' }}>
                        Confirm Deletion
                    </Typography>
                </Box>
                <Divider />
                <Box sx={{ px: 2.5, py: 2 }}>
                    <Typography variant="body2" color="text.secondary">
                        Are you sure you want to delete{' '}
                        <Typography component="span" variant="body2" fontWeight={700} color="error.main">
                            {Array.isArray(selectionModel)
                                ? selectionModel.length
                                : selectionModel?.size || 0}
                        </Typography>
                        {' '}consignee(s)? This action cannot be undone.
                    </Typography>
                </Box>
                <Divider />
                <Box sx={{ px: 2.5, py: 1.5, display: 'flex', justifyContent: 'flex-end', gap: 1 }}>
                    <Button onClick={() => setConfirmOpen(false)} variant="outlined" color="inherit" size="small" disabled={deleting}>Cancel</Button>
                    <Button color="error" variant="contained" size="small" disabled={deleting}
                        startIcon={deleting ? <CircularProgress size={14} color="inherit" /> : <DeleteIcon />}
                        onClick={() => handleDelete()}>{deleting ? 'Deleting…' : 'Delete'}</Button>
                </Box>
            </Dialog>

        </Box>
    );
}